var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessToast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.448725 5.94926C0.477117 2.65585 3.15497 0.000982298 6.4485 0.000982064L83.6562 0.000976562C77.0197 21.3092 66.2287 41.0095 52.097 58.001L6.05195 58.001C2.71802 58.001 0.0234305 55.2831 0.0521704 51.9493L0.448725 5.94926Z",
    fill: "#4C862E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2037 0.000379959L6.00003 2.95292e-05C2.68631 1.32207e-05 3.15214e-06 2.68631 3.15214e-06 6.00003V52.001C3.15214e-06 55.3147 2.68629 58.001 6 58.001H46.4998C60.3028 41.0025 70.8015 21.1822 77.2037 0.000379959Z",
    fill: "#82BD54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27.6296V29.0096C43.9981 32.2442 42.9507 35.3916 41.014 37.9823C39.0772 40.573 36.3549 42.4683 33.253 43.3854C30.1511 44.3025 26.8359 44.1924 23.8017 43.0714C20.7675 41.9505 18.177 39.8787 16.4164 37.1652C14.6559 34.4516 13.8197 31.2417 14.0325 28.014C14.2453 24.7864 15.4958 21.714 17.5974 19.2552C19.699 16.7963 22.5392 15.0826 25.6943 14.3698C28.8494 13.6569 32.1504 13.9831 35.105 15.2996",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 17.4625L28.9114 32.4625L24.3848 27.967",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToast);
export default __webpack_public_path__ + "static/media/successToast.68d5d60210356c6fe9e8842b082abba7.svg";
export { ForwardRef as ReactComponent };